// extracted by mini-css-extract-plugin
export default {"root":"PillLabel_root__kpL5+","uppercase":"PillLabel_uppercase__85hZz"};